

import { greyTheme as appGreyTheme } from './greyTheme';
import { whiteTheme as appWhiteTheme } from './whiteTheme';
import { blackTheme as appBlackTheme } from './blackTheme';
import { additionalWhite1 } from './additionalWhiteTheme_1';
import { additionalWhite_2 } from './additionalWhiteTheme_2';
import { additionalGreyTheme } from './additionalGreyTheme';

import { ApplicationTheme as uiApplicationTheme } from '@brg/ui';
import { greenawardTheme } from './greenawardTheme';

const greyTheme = {...uiApplicationTheme.grey, ...appGreyTheme}
const whiteTheme = {...uiApplicationTheme.white, ...appWhiteTheme}
const additionalWhite__1 = {...uiApplicationTheme.white, ...additionalWhite1}
const greenawardThemes = {...uiApplicationTheme.white, ...greenawardTheme}
const blackTheme = {...uiApplicationTheme.black, ...appBlackTheme}

export type ApplicationThemeT = typeof greyTheme;

declare module 'styled-components' {
    export interface DefaultTheme extends ApplicationThemeT {}
}

export const ApplicationTheme = {
    grey: greyTheme as ApplicationThemeT,
    white: whiteTheme as ApplicationThemeT,
    black: blackTheme as ApplicationThemeT,
    additionalWhite_1: additionalWhite__1 as ApplicationThemeT,
    additionalWhite_2: additionalWhite_2 as ApplicationThemeT,
    additionalGreyTheme: additionalGreyTheme as ApplicationThemeT,
    greenawardThemes: greenawardThemes as ApplicationThemeT ,
};


import { greyTheme as appGreyTheme } from './greyTheme';
import { whiteTheme as appWhiteTheme } from './whiteTheme';
import { blackTheme as appBlackTheme } from './blackTheme';
import { additionalWhite1 } from './additionalWhiteTheme_1';
import { additionalWhite_2 } from './additionalWhiteTheme_2';
import { additionalGreyTheme } from './additionalGreyTheme';

import { ApplicationTheme as uiApplicationTheme } from '@brg/ui';
import { greenawardTheme } from './greenawardTheme';

const greyTheme = {...uiApplicationTheme.grey, ...appGreyTheme}
const whiteTheme = {...uiApplicationTheme.white, ...appWhiteTheme}
const additionalWhite__1 = {...uiApplicationTheme.white, ...additionalWhite1}
const greenawardThemes = {...uiApplicationTheme.white, ...greenawardTheme}
const blackTheme = {...uiApplicationTheme.black, ...appBlackTheme}

export type ApplicationThemeT = typeof greyTheme;

declare module 'styled-components' {
    export interface DefaultTheme extends ApplicationThemeT {}
}

export const ApplicationTheme = {
    grey: greyTheme as ApplicationThemeT,
    white: whiteTheme as ApplicationThemeT,
    black: blackTheme as ApplicationThemeT,
    additionalWhite_1: additionalWhite__1 as ApplicationThemeT,
    additionalWhite_2: additionalWhite_2 as ApplicationThemeT,
    additionalGreyTheme: additionalGreyTheme as ApplicationThemeT,
    greenawardThemes: greenawardThemes as ApplicationThemeT ,
};
